/* ── Overlay ──────────────────────────────────────────────── */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(4, 13, 24, 0.85);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 24px var(--sp-4) var(--sp-4);
  z-index: 200;
  overflow-y: auto;
}

.modal {
  width: 100%;
  max-width: 520px;
  background: var(--color-surface);
  border: 1px solid var(--color-border-med);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-strong);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 48px);
  overflow: hidden;
}

/* ── Header ──────────────────────────────────────────────── */
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-5) var(--sp-6);
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.titleRow {
  display: flex;
  align-items: flex-start;
  gap: var(--sp-3);
}

.titleIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  background: rgba(56, 189, 248, 0.1);
  color: var(--color-sky);
  flex-shrink: 0;
}

.title {
  font-family: var(--font-mono);
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text);
  letter-spacing: 0.5px;
}

.sub {
  font-size: 12px;
  color: var(--color-text-muted);
  margin-top: 4px;
  line-height: 1.5;
}

.closeBtn {
  background: none;
  border: none;
  color: var(--color-text-muted);
  font-size: 18px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  line-height: 1;
  flex-shrink: 0;
  transition: color 0.15s, background 0.15s;
}

.closeBtn:hover { color: var(--color-text); background: rgba(255,255,255,0.05); }

/* ── Body ────────────────────────────────────────────────── */
.body {
  padding: var(--sp-5) var(--sp-6);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.section { display: flex; flex-direction: column; gap: var(--sp-2); }

.sectionHeading {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.paragraph {
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-text);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  padding-left: 1.1em;
  font-size: 13px;
  line-height: 1.6;
  color: var(--color-text);
}

.list li { list-style: disc; }

/* ── Footer ──────────────────────────────────────────────── */
.footer {
  padding: var(--sp-4) var(--sp-6);
  border-top: 1px solid var(--color-border);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.footerLabel {
  font-family: var(--font-mono);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.footerRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-3);
}

.promptText {
  font-size: 13px;
  font-style: italic;
  color: var(--color-text-muted);
}

.askBtn {
  flex-shrink: 0;
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  padding: var(--sp-2) var(--sp-4);
  border-radius: var(--radius-sm);
  background: rgba(56, 189, 248, 0.1);
  border: 1px solid rgba(56, 189, 248, 0.2);
  color: var(--color-sky);
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.askBtn:hover { background: rgba(56, 189, 248, 0.18); border-color: rgba(56, 189, 248, 0.4); }
